import './index.css';

import ReactDOM from 'react-dom/client';

import { initSplashScreen } from './utils/splash';
import { observeReactPerformance } from './services/devPerformance';

initSplashScreen();

if (import.meta.env.DEV) {
  const stopObserving = observeReactPerformance();
  import.meta.hot?.dispose(stopObserving);
}

async function init() {
  const [{ default: App }, { default: RootErrorBoundary }] = await Promise.all([
    import('./App'),
    import('./components/common/RootErrorBoundary'),
  ]);
  // TODO: consider adding StrictMode
  // It's important to note that it will cause double effects in dev mode!
  ReactDOM.createRoot(document.getElementById('app')!).render(
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  );
}

init();
